<template>
  <div>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" width="500px" :show-close="false" :append-to-body="true" title="绑定手机号" :visible.sync="dialogBindPhone">
      <el-form ref="form" :hide-required-asterisk="true" :model="form.data" :rules="form.rules" label-width="4em">
        <el-form-item label="用户名">
          <p>{{ userInfo.userName }}</p>
        </el-form-item>
        <el-form-item prop="phone" label="手机号">
          <el-input v-model="form.data.phone" placeholder="请输入手机号" />
        </el-form-item>
        <!-- <el-form-item label-width="0">
          <drag-verify ref="verify" class="slider" :height="dragverify.height" :text="dragverify.text" :success-text="dragverify.successText" :background="dragverify.background" :circle="dragverify.circle" :width="dragverify.width" />
        </el-form-item> -->
        <el-form-item prop="code" label="验证码">
          <el-row>
            <el-col :span="13">
              <el-input v-model="form.data.code" placeholder="请输入验证码" />
            </el-col>
            <el-col :push="1" :span="8">
              <el-button class="code-btn" :disabled="phoneCode.disabled" @click="getPhoneCode">{{ phoneCode.sendCodeText }}{{ typeof phoneCode.sendCodeText === 'number' ? 's' : '' }}</el-button>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" class="button" @click="bindPhoneSub">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { CountDown } from '@/utils/common'
import { getPhoneCode } from '@/api/common'
import { staffAll } from '@/api/personal/enterprise'
// import dragVerify from 'vue-drag-verify'

export default {
  name: 'BindPhone',
  // components: { dragVerify },
  data() {
    return {
      // dialogBindPhone: true,
      // 手机验证码相关
      phoneCode: {
        disabled: false,
        sendCodeText: '获取验证码',
        timer: null
      },
      // 表单相关
      form: {
        data: {
          phone: '',
          code: ''
        },
        rules: {
          phone: [{ validator: this.$validate('phone'), required: true }],
          code: [{ validator: this.$validate('code'), required: true }]
        }
      },
      // 滑块验证码相关
      dragverify: {
        height: 40,
        width: 460,
        circle: false,
        background: '#fff',
        text: '请按住滑块，拖动到最右边',
        successText: '验证成功'
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'dialogBindPhone'])
  },
  watch: {
    phone() {
      console.log(this.phone)
    }
  },
  methods: {
    // 获取手机验证码
    getPhoneCode() {
      this.$refs.form.validateField('phone', (valid, str) => {
        if (!valid) { // 验证成功返回null
          this.setTimer()
          getPhoneCode({ phone: this.form.data.phone }).then(res => {
            // 由于方便测试每次从后台获取验证码自动填入表单
            this.form.data.code = res.result
          })
        }
      })
    },
    // 设置定时器
    setTimer() {
      const phoneCode = this.phoneCode
      phoneCode.disabled = true
      // 倒计时时间
      phoneCode.sendCodeText = CountDown
      phoneCode.timer = setInterval(() => {
        if (phoneCode.sendCodeText <= 0) {
          phoneCode.sendCodeText = '重新获取'
          // 关闭并清空定时器
          clearInterval(phoneCode.timer)
          phoneCode.timer = null
          phoneCode.disabled = false
        } else {
          phoneCode.sendCodeText--
        }
      }, 1000)
    },
    bindPhoneSub() {
      this.$refs.form.validate(valid => {
        if (valid) {
          staffAll({
            methodName: 'updateUserName',
            userName: this.userInfo.userName,
            ...this.form.data
          }).then(res => {
            this.$store.dispatch('user/getInfo')
          })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.button,.el-button--primary:focus, .el-button--primary:hover{
  color: #fff;
  background-color: $base-color;
  border-color: $base-color;
}
</style>
